/** A Social Digest theme handed to the Strategist page to open a chat about. */
export interface SeedTheme {
  briefId: string;
  themeId: string;
}

/**
 * What another page may hand the Strategist, to become its first message.
 *
 * - `theme`: "Write Post with Strategist" on Trends (and the Dashboard's trends widget). The server
 *   writes the prompt from the theme.
 * - `prompt`: the Dashboard's "What do you want to write about?" box. The prompt is what was typed.
 */
export type ChatSeed = { kind: 'theme'; theme: SeedTheme } | { kind: 'prompt'; text: string };

/**
 * The longest message the server takes (SendMessageDto's @MaxLength). The Dashboard box stops at it,
 * so the cut in readChatSeed only ever applies to state that did not come from that box.
 */
export const SEED_PROMPT_MAX = 8000;

/**
 * Read a seed out of router history state.
 *
 * History state is arbitrary data — it outlives a reload and anything can have put it there — so a
 * prompt is taken only when it really is non-blank text, and is cut to what the server accepts
 * rather than sent to be refused.
 */
export function readChatSeed(state: unknown): ChatSeed | null {
  if (!state || typeof state !== 'object') return null;
  const { seedTheme, seedPrompt } = state as { seedTheme?: SeedTheme; seedPrompt?: unknown };
  if (seedTheme) return { kind: 'theme', theme: seedTheme };
  if (typeof seedPrompt === 'string' && seedPrompt.trim() !== '') {
    return { kind: 'prompt', text: seedPrompt.trim().slice(0, SEED_PROMPT_MAX) };
  }
  return null;
}
